import MetadataWorkspace, {
  buildSeriesSet,
  extractCustomValues,
  mergeSeriesValues,
  normalizeValue,
  splitInputValues,
} from './metadata/MetadataWorkspace';

export {
  buildSeriesSet,
  extractCustomValues,
  mergeSeriesValues,
  normalizeValue,
  splitInputValues,
};

export type { MetadataWorkspaceProps as MetadataEditFormProps } from './metadata/MetadataWorkspace';

export default MetadataWorkspace;
